export const tr = {
    home: 'Ana Sayfa',
    engneeringtext : 'Mühendislik Bölümü',
    umbrellatext : 'Gölge Sistemleri Bölümü',
    engneeringdesc : 'Archotek iç ve dış mimarlık alanında, ayrıca gölgelendirme sistemleri, kameriyye ve tente ile bahçe düzenlemeleri, proje yönetimi, proje maliyet hesabı ve ekonomik fizibilite için kapsamlı etüt çalışması gibi çeşitli faaliyetlerde uzmanlaşmış mimarlık şirketidir.',
    umbrelladesc : 'Çeşitli mimari işlere ek olarak, iç dekorasyon alanında farklı alanlar için; teraslar, kafeteryalar, bahçeler, düğünler ve diğer hayati olaylarda, yaz aylarında, kış aylarında ve yılın her mevsiminde topluma hizmet veren gölgelendirme sanatını tanıtmaya çalışıyoruz.Şirket, bu alanda çalışan önde gelen mühendislik şirketleri ve ofisleri arasında yer almasını sağlayan tecrübe ve başarılara sahiptir.',
    contacts : 'Daha fazla bilgi almak için lütfen bize mail atın veya “Bize ulaşın” formunu doldurun.',
    blog : 'Blog',
    underlatest : 'Bu tamamlanmış en son projeleri içeren fotoğraf koleksiyonudur.',
    latestprojects : 'En son projelerimiz',
    projects : 'Projelerimiz',
    shortaboutus : 'Tasarım ve iç koordinasyon dahilinde, Archotek, mekana günlük kullanımlara uygun, modern ve zarif bir tasarım sunan mobil tente tasarımları yardımıyla mimari alan ile onu saran çevreyi birbirine bağlamayı amaçlıyor.',
    team : 'Ekibimiz',
    about : 'Hakkımızda',
    contactus : 'iletişim',
    memareng : 'Mimar',
    dekoreng : 'İç Mimar',
    sobhi : 'M.Soubhi MOUKHALLATI',
    aktaa : 'Mohamad AKTAA',
    daddi : 'Zaher DAADI',
    ourmessage : 'Misyonumuz',
    ourvesion : 'Vizyonumuz',
    outgoals : 'Hedeflerimiz',
    outvalues : 'Değerlerimiz',
    goalsdesc : 'Hedefimiz, mimari hizmetler sağlamak ve müşterilerimizle son derece güçlü ve değerli ilişkiler bağlamında tasarım gerçekleştirmektir. Bu eğilimi desteklemek için, ekibimiz müşterinin fikirlerini anlamak için elinden gelenin en iyisini yapıyor. Bununla birlikte, müşterinin hayalini gerçekleştirmek ve projesini hayata geçirmek için yaratıcılığın ve yeniliğin en iyisini yapmaya çalışıyor.',
    vesiondesc : 'Her müşterinin bütçesiyle uyumlu, estetik ihtiyaçlarını karşılayan benzersiz ve yenilikçi tasarımlar için çözümler bulma, müşterilerimize proje yönetimindeki son gelişmeleri yansıtan teknik becerilerle desteklenmiş kapsamlı bir bilgi tabanı sağlama, ürünlerimizin ve kaliteli hizmetlerimizin hızlı ve zamanında teslimi.',
    valuesdesc : 'Her müşterinin farklı zevkleri, özel talepleri ve benzersiz olduğuna inanıyoruz. Bu eğilimi desteklemek için, Archotek ekibi, müşterinin fikirlerini anlamak için elinden gelenin en iyisini yapıyor. Bununla birlikte, müşterinin hayalini gerçekleştirmek ve projesini hayata geçirmek için yaratıcılığın ve yeniliğin en iyisini yapmaya çalışıyor.',
    messagedesc : 'Archotek, yenilikçi ve taklit olmayan yollarla materyalleri ve yenilikçi imkanları kullanan seçkin ve benzersiz bir tasarım sunmayı amaçlıyor. Şirket, müşteri ilişkilerinden tasarıma kadar tüm yönleriyle ekip çalışmasına odaklanıyor.',
    babii : 'Mohamad BABI',
    salesmanager : 'Satış Müdürü',
    readmore : 'daha fazla oku',
    socialmedia : 'Sosyal Medya',
    all : 'Tüm',
    contactsturkey : 'Merkez Ofis (Türkiye)',
    contactsksa : 'Şube 1 (Suudi Arabistan)',
    send : 'Gönder',
    turkyadress : 'Cihangir Mah. Meşrutiyet Cad. Mehtar Sok. No:1A/0 Acvılar - Istanbul/Turkey',
    ksaadress : 'Riyad – Mahrac 11 Al Rawdah Caddesi Abdul Rahman Al Gafaki Caddesi',
    gallery : ' Galeri',
    name : 'Ad',
    email : 'E-posta',
    message : 'Mesaj',
    newsletter : 'bülten'
}
export const ar = {
    home: "الرئيسية",
    engneeringtext : 'القسم الهندسي',
    umbrellatext : 'قسم المظلات ',
    engneeringdesc : 'Archotek هي شركة معمارية متخصصة في مجال العمارة الداخلية والخارجية فضلا عن بعض الأنشطة المتنوعة الأخرى مثل انظمة التظليل وتنسيق الحدائق بالعرائش والمظلات و ادارة المشاريع و حساب الكميات للمشاريع وعمل دراسة شامله للجدوى الإقتصادية',
    umbrelladesc : 'بالإضافة للاعمال المعمارية المختلفة لدينا نسعى إلى ادخال فن التظليل في مجال الديكور الداخلي لمختلف المجالات في التراسات والكافيتريات والحدائق والاعراس وغيرها من الفعاليات الحيوية التي تخدم المجتمع صيفا وشتاء وفي كل مواسم السنة',
    underlatest : 'هذه مجموعة من الصور التي تضم احدث المشاريع المنجزة ',
    contacts : 'وللمزيد من الاستفسارات لا تتردد في مراسلتنا عبر البريد الالكتروني أو ملء نموذج الاتصال بنا. ',
    blog : 'المدونة',
    latestprojects : 'أحدث مشاريعنا',
    projects : 'مشاريعنا',
    shortaboutus : '  ومن ضمن التصميم والتنسيق الداخلي تسعى Archotek لعمل صلة وصل بين الفراغ المعماري والبيئة المحيطة فيه من خلال تصميم المظلات المتحركة التي تعطي للفراع تصميم عصري وانيق ويناسب كافة الاستخدامات اليومية',
    team : 'فريقنا',
    about : 'من نحن',
    contactus : 'اتصل بنا',
    memareng : 'مهندس معماري',
    dekoreng : 'مهندس ديكور',
    sobhi : 'محمد صبحي مخللاتي',
    aktaa : 'محمد أكتع',
    daddi : 'زاهر ضعضي',
    ourmessage : 'رسالتنا',
    ourvesion : 'رؤيتنا',
    outgoals : 'أهدافنا',
    outvalues : 'قيمنا',
    goalsdesc : 'هدفنا هو توفير خدمات هندسة معمارية وتصميم في سياق علاقات قوية بشكل استثنائي ومجزي مع عملائنا، وسعياً لدعم هذا التوجه يبذل فريق عملنا جل جهده لفهم أفكار العميل وإضافة أفضل ماعنده من إبداع وابتكار لتحقيق حلم العميل وجعل مشروعه واقعاً حقيقيا.',
    vesiondesc : 'إيجاد حلول لتصاميم فريدة ومبتكرة تلبي الاحتياجات الجمالية لكل عميل وبما يتناسب مع ميزانيته، تزويد زبائننا بقاعدة معرفية متنامية ومدعمة بالمهارات التقنية التي تعكس أحدث التطورات في مجال إدارة المشاريع، التسليم الفوري وفي الوقت المناسب لمنتجاتنا وخدماتنا عالية الجودة.',
    valuesdesc : 'نؤمن بأن كل عميل لديه ذوق مختلف و متطلبات خاصة و فريدة من نوعها ، وسعياً لدعم هذا التوجه يبذل فريق عمل Archotek كل جهده لفهم أفكار العميل وإضافة أفضل ماعنده من إبداع وإبتكار لتحقيق حلم العميل وجعل مشروعه واقعاً حقيقياً.',
    messagedesc : 'تسعى شركة Archotek إلى تقديم التصميم المميز والفريد الذي يوظف المواد والإمكانات المتاحة بطرق إبداعية وغير تقليدية ، تركز الشركة على العمل الجماعي في كافة الجوانب من العلاقات مع الزبائن إلى التصميم.',
    babii : 'محمد بابي',
    salesmanager : 'مدير المبيعات',
    readmore : 'اقرأ المزيد',
    socialmedia : 'وسائل التواصل الاجتماعي',
    all : 'الكل',
    contactsturkey : 'الفرع الرئيسي (تركيا)',
    contactsksa : 'فرع 1 (المملكة العربية السعودية )',
    send : 'ارسال',
    turkyadress : 'Cihangir Mah. Meşrutiyet Cad. Mehtar Sok. No:1A/0 Acvılar - Istanbul/Turkey',
    ksaadress : 'الرياض – مخرج 11 حي الروضة شارع عبد الرحمن الغافقي',
    gallery : 'معرض الصور',
    name : 'الاسم',
    email : 'البريد الالكتروني',
    message : 'الرسالة',
    newsletter : 'النشرة البريدية'
    

}


export const en = {
    home: "Home",
    engneeringtext : 'Engineering department',
    umbrellatext : 'Department of Awnings',
    engneeringdesc : 'Archotek is an architectural company specialized in the field of interior and exterior architecture as well as some other activities such as shading systems, landscaping, parachutes and umbrellas, project management, project quantity calculation, and a comprehensive study of economic feasibility',
    umbrelladesc : 'In addition to the various architectural works, we seek to introduce the art of shading in the field of interior decoration of various areas in terraces, cafeterias, gardens, weddings and other vital events that serve the community in summer and winter and all seasons of the year',
    underlatest : 'This is a collection of photos that includes the latest projects completed',
    contacts : "For more information please mail us or fill the contacts form",
    blog : 'Blog',
    latestprojects : 'Our latest projects',
    projects : 'Our projects',
    shortaboutus : 'Archotek seeks to create a link between the architectural vacuum and the surrounding environment through the design of mobile umbrellas that give the craft a modern and elegant design that suits all everyday uses.',
    team : 'Our team',
    about : 'About',
    contactus : 'Contacts',
    memareng : "Architect",
    dekoreng : 'Decoration Engineer',
    sobhi : 'محمد صبحي مخللاتي',
    aktaa : 'Mohammad aktaa',
    daddi : 'Zaher daadi',
    ourmessage : 'Our Mission',
    ourvesion : 'Our vision',
    outgoals : 'Our goals',
    outvalues : 'Our values and beliefs',
    goalsdesc : "Our goal is to provide architectural and design services in the context of exceptionally strong and rewarding relationships with our customers. In order to support this approach, our team strives to understand customer ideas and add the best of its creativity and innovation to achieve the client's dream and make his project a reality.",
    vesiondesc : "Providing solutions to unique and innovative designs that meet the aesthetic needs of each client and in line with its budget, providing our customers with a growing knowledge base supported by technical skills that reflect the latest developments in project management, prompt and timely delivery of our high quality products and services.",
    valuesdesc : "We believe that each customer has different tastes and unique requirements. In order to support this approach, Archotek's team strives to understand customer ideas and add the best of its creativity and innovation to realize the customer's dream and make his project a reality.",
    messagedesc : "Archotek seeks to deliver a unique and distinctive design that utilizes the materials and capabilities available in creative and non-traditional ways. The company focuses on teamwork in all aspects from customer relations to design.",
    babii : 'Mohammed babii',
    salesmanager : 'Sales manager',
    readmore : 'More',
    socialmedia : 'Social Media',
    all : 'All',
    contactsturkey : 'Main Branch (Turkey)',
    contactsksa : 'Branch 1 (Saudi Arabia)',
    send : 'Send',
    turkyadress : 'Cihangir Mah. Meşrutiyet Cad. Mehtar Sok. No:1A/0 Acvılar - Istanbul/Turkey',
    ksaadress : 'Riyadh - Director 11 Al-Rawdah Street Abdul Rahman Al-Ghafaki Street',
    gallery : 'Gallery',
    name : 'Name',
    email : 'Email',
    message : 'Message',
    newsletter : 'News Letter'
    

}
export const languages = {
    tr : {
        name : 'turkce',
        code : 'tr',
    },
    ar : {
        name : 'العربية',
        code : 'ar',
    },
    en : {
        name : 'English',
        code : 'en',
    }
}

export const currentLang = function(){
    let def = window.localStorage.getItem('vue-lang')
    console.log(def)
    if(typeof def === 'undefined'){
        return 'ar'
    }else{
        return def
    }
}


// WEBPACK FOOTER //
// ./src/strings.js